/** IndexedDB layout (Dexie). Only non-identifying fields are stored in the clear, for indexing:
 * record type, the patient's random UUID, timestamps, sync state. Everything clinical is sealed. */
import { Dexie } from 'dexie';
export class AssistDb extends Dexie {
    records;
    outbox;
    deadletter;
    meta;
    keyring;
    constructor(name) {
        super(name);
        this.version(1).stores({
            records: '&key, type, patientId, pending, updatedAt, keyId',
            outbox: '&opId, seq, key, keyId',
            deadletter: '&opId, key, keyId',
            meta: '&k',
            keyring: '&userId',
        });
    }
}
//# sourceMappingURL=db.js.map